import React from "react";
import { Route, Redirect } from "react-router";
import lodash from "lodash";
import axios from "axios";
import config from "../config";
import { logOpenEvent } from "../api";

class UnProtectedRoute extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      user: this.props.user,
      isAuthChecked: this.props.isAuthChecked
    }
  }

  componentDidMount() {
    window.addEventListener("error", async (event) => {
      // LOG ERROR EVENT HERE for unauthorized user.
      const payload = {
          type: 'ErrorEvent',
          url: this.props?.location?.pathname,
          filename: event?.filename,
          line_no: event?.lineno,
          message: event?.message,
          errorMessage: event?.error?.message,
          stack: event?.error?.stack,

          currentUrl: this.props?.location?.pathname,
          screenHeight: window.innerHeight,
          screenWidth: window.innerWidth
      }
      await logOpenEvent(payload);
    });
    axios
        .get(`${config.backend_url}/isAuth`)
        .then((res) => {
          if (res.data.success) {
            this.setState({ user: res.data.user});
          }
        })
        .catch((err) => {
        })
        .finally(() => {
          this.setState({ isAuthChecked: true});
        });
  }

  render() {
    if(this.state.isAuthChecked) {
      return (
        <Route {...this.props} render={newProps => { 
          if (lodash.isEmpty(this.state.user)) {
            const { comp: Component } = this.props;
            return <Component {...newProps} />;
          } else {
            return <Redirect
              to={{
                pathname: "/home",
                state: {from: this.props.location}
              }}
            />
          } 
        }}/>
      );
    } else return <div className="init-render"></div>;
  }
}

export default UnProtectedRoute;
